var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8636 22.2727H12.7273V19.0909H23.8636V22.2727ZM28.6364 15.9091H12.7273V12.7273H28.6364V15.9091ZM28.6364 9.54545H12.7273V6.36364H28.6364V9.54545ZM3.18182 6.36364V31.8182H28.6364V35H3.18182C2.33795 35 1.52864 34.6648 0.931933 34.0681C0.335226 33.4714 0 32.6621 0 31.8182V6.36364H3.18182ZM31.8182 0C32.6621 0 33.4714 0.335226 34.0681 0.931933C34.6648 1.52864 35 2.33795 35 3.18182V25.4545C35 27.2205 33.5841 28.6364 31.8182 28.6364H9.54545C8.70158 28.6364 7.89228 28.3011 7.29557 27.7044C6.69886 27.1077 6.36364 26.2984 6.36364 25.4545V3.18182C6.36364 1.41591 7.77955 0 9.54545 0H31.8182ZM9.54545 3.18182V25.4545H31.8182V3.18182H9.54545Z",
    fill: "#54555A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.49e20c1f27bdcfb85afbb4e11a673944.svg";
export { ForwardRef as ReactComponent };